import React from 'react'
import { Box, Typography, Alert } from '@mui/material'

/**
 * Permissions Section Component - STUB
 * TODO: Implement patient visibility and EMR permissions
 */
export default function PermissionsSection({ data, onChange, disabled, loading, error }) {
  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Patient Access Permissions
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        TODO: Implement visibility scope and permission toggles
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Alert severity="info">
        This section needs implementation. See SPRINT.md for details.
      </Alert>
    </Box>
  )
}
